import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { EvaButtonModule } from "../eva-button/eva-button.module";
import { UserRecentActivityCardComponent } from './user-recent-activity-card/user-recent-activity-card.component';
import { UserRecentActivityComponent } from './user-recent-activity.component';
import { SliderProModule } from '../slider-pro/slider-pro.module';
import { TextModule } from "../text/text.module";
import { UserRecentActivityCardV2Component } from './user-recent-activity-card-v2/user-recent-activity-card-v2.component';
import { ReviewScoreModule } from '../review-score/review-score.module';

@NgModule({
    declarations: [
        UserRecentActivityComponent,
        UserRecentActivityCardComponent,
        UserRecentActivityCardV2Component
    ],
    exports: [
      UserRecentActivityComponent
    ],
    imports: [
        CommonModule,
        TranslateModule,
        EvaButtonModule,
        SliderProModule,
        ReviewScoreModule,
        TextModule
    ]
})
export class UserRecentActivityModule { }
